import globals from "imports/globals";
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

const component = (function () {
    $(window).on("load", function () {
        /**
         * Hero
         */
        $("#hero").find(".slide-up").addClass("on");
        setTimeout(function () {
            $("#hero").find(".slant-left, .slant-right").removeClass("clip-y").addClass("on");
        }, 640);

        /**
         * Zoom In
         */
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.create({
            trigger: $("#zoom-in")[0],
            start: "top center",
            endTrigger: "html",
            end: "bottom top",
            onToggle: (self) => {
                if (self.isActive) {
                    var color = $(self.trigger).attr("data-theme-to");
                    $("html").attr("data-theme", color);
                    $(self.trigger).find(".zoom-in").addClass("on");
                } else {
                    $("html").attr("data-theme", "");
                    $(self.trigger).find(".zoom-in").removeClass("on");
                }
            },
            // markers: true,
        });

        /*
        $(".image-gallery-image").each(function () {
            ScrollTrigger.create({
                trigger: $(this)[0],
                start: "top bottom-=10%",
                endTrigger: "html",
                end: "bottom top",
                onToggle: (self) => {
                    if (self.isActive) {
                        $(self.trigger).addClass("on");
                    } else {
                        $(self.trigger).removeClass("on");
                    }
                },
                // markers: true,
            });
        });
        */

        $(".image-gallery").each(function () {
            ScrollTrigger.create({
                trigger: $(this)[0],
                start: "top bottom-=10%",
                endTrigger: "html",
                end: "bottom top",
                onToggle: (self) => {
                    if (self.isActive) {
                        $(self.trigger)
                            .find(".image-gallery-image")
                            .each(function (_i, _el) {
                                setTimeout(function () {
                                    $(_el).addClass("on");
                                }, _i * 100);
                            });
                    } else {
                        $(self.trigger).find(".image-gallery-image").removeClass("on");
                    }
                },
                // markers: true,
            });
        });
    });
})();

export default component;
